/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { useNavigate, useParams } from 'react-router';

import { useAppDispatch, useAppSelector } from 'store';
import { IEventsItem } from 'store/slices/events/interfaces';
import {
  bulkUpdateEventsItem,
  loadEventsItem,
} from 'store/slices/events/actions';
import { serializeSelectPriorityItem } from 'utils/mappings';
import { StatusesEnum } from 'constants/status';
import CardSpin from 'components/Card/CardSpin';
import { IFormProps, SampleEditForm } from 'components/Sample/SampleEditForm';
import { urls } from 'store/api';
import { EntitySelect } from 'components/form/AsyncSelect/EntitySelect';

interface IProps {
  sortFieldName?: keyof Pick<
    IEventsItem,
    'sortPriority' | 'sortPriorityMainPage'
  >;
  slug: string;
  params?: Record<string, any>;
}

export const Edit: React.FC<IProps> = ({
  sortFieldName = 'sortPriority',
  slug,
  params = {},
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [queryLoading, setQueryLoading] = useState(!!id);
  const data = useAppSelector(state => state.events);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const onSubmit = (params: IFormProps<IEventsItem>) => {
    const data = params.values;
    const prevItem =
      id && Number(id) != data.id
        ? { id: Number(id), [sortFieldName]: null, showOnMainPage: false }
        : {};
    const updateElements = [
      {
        id: data.id,
        [sortFieldName]: params.sortPriority,
        showOnMainPage: true,
      },
      prevItem,
    ].filter(el => el.id);
    dispatch(bulkUpdateEventsItem(updateElements))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно изменена',
        });
        navigate(slug);
      })
      .catch(() => setIsLoading(false));
  };

  const handleCancel = () => {
    navigate(slug);
  };

  const initialValues = serializeSelectPriorityItem({
    values: data.item,
    sortFieldName,
  });

  useEffect(() => {
    if (id) {
      dispatch(loadEventsItem(id))
        .unwrap()
        .finally(() => {
          setQueryLoading(false);
        });
    }
  }, [id]);

  if (queryLoading) {
    return <CardSpin />;
  }

  const Select = () => (
    <EntitySelect
      name='values'
      label='Событие'
      placeholder='Выберите событие'
      additional={{
        status: StatusesEnum.PUBLISHED,
        sort: `${sortFieldName}`,
        ...params,
      }}
      required
      requestUrl={urls.api.events.get}
    />
  );

  return (
    <SampleEditForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      handleCancel={handleCancel}
      isLoading={isLoading}
      select={Select}
    />
  );
};
